/**
 * 
 * Validation for inputs (by regex) and for select boxes (if select.value ).
 * 
 * All selects and inputs are pushed to the 'invalids' object.
 * 
 * If they pass validation, they are omitted from the object.
 * IF the object is empty of inputs/selects, the form will be successfull.
 * 
 * To overwrite cf7 default submit, a hidden input is used with the id 'custom_validation'.
 * 
 * Passing the validation will give it a value. Failing it will make it empty. If it is empty, the form will not submit.
 * 
 * 
 */


window.Cloud_form = function(formName) {
    this.form = document.querySelector(formName);
    this.invalids = {};
    this.shadow = document.createElement('div');
    this.start = (function() {
        if (!this.form) return;
        for (var key in this) {
            if (typeof this[key] === "function" && key.indexOf('_') !== 0) {
                this[key]();
            }
        }
    }.bind(this))();
}

window.Cf = Cloud_form.prototype;
const email_validation = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

Cf.validation = {
    project_name: {
        pattern: '^[a-zA-Z1-9+_- "]+$',
        help: `Allowed only latin characters, numbers, spaces, '+', ", or '_'.`,
    },
    full_name: {
        pattern: '^[a-zA-Z1-9_- ]+$',
        help: `Allowed only latin characters, numbers, spaces, '+', ", or '_'.`,
    },
    Remail: {
        pattern: 'email',
        help: `Allowed only latin characters, numbers, '_', '-', and '@'.`
    },
    guide_or_email: {
        pattern: 'email',
        help: `Allowed only latin characters, numbers, '_', '-', and '@'.`,
    },
    email_for_notifications: {
        pattern: 'email',
        help: `Allowed only latin characters, numbers, '_', '-', and '@'.`,
    },
    Rphone: {
        pattern: '^[0-9-+].{8,20}$',
        help: `Allowed only numbers, '-', or '+'. Numbers of digits - 9 - 20`
    },
    budget: {
        pattern: '^[0-9]+$',
        min: 99,
        max: 999999,
        help: `Allowed only numeric value from 100 to 999999`
    },
};
Cf._get_invalid_keys = function() {
    return Object.keys(this.invalids).filter((key) => { return this.invalids[key] !== null; });
};
Cf._create_warn_label = function(str) {
    // setup the warn span
    var warn = document.createElement('span');
    warn.className = 'cf-validation-warn';
    warn.textContent = str;
    warn.setAttribute('role', 'alert');

    return warn;
};
Cf._pass_validation = function() {

    var validation_hidden_input = document.getElementById('custom_validation');

    if (!validation_hidden_input) {
        console.log(
            `%cHidden validation input is not present. Create \n [text* custom_validation id:custom_validation] \n in the form body for validation to work.`,
            'display:block;padding: 4px 10px; font-weight: bold; background:yellow;');
        return;
    }
    if (!this._get_invalid_keys().length) {
        document.getElementById('custom_validation').value = 'pass validation';
    } else {
        document.getElementById('custom_validation').value = '';
    }

};

Cf.default_select = function() {

    const selectsCells = this.form.querySelectorAll('[data-selected]');

    selectsCells.length && [].forEach.call(selectsCells, (item) => {

        const selected = item.getAttribute('data-selected'),
            selects = item.querySelectorAll('select');

        selects.length && [].forEach.call(selects, (select) => {

            select.options.length && [].forEach.call(select.options, (option) => {

                if (option.text.toLowerCase() === selected.toLowerCase()) {
                    option.setAttribute('selected', 'selected');
                }

            });
        });

    });
};

Cf._string_validation = function(input) {
    if (input.pattern === 'email') {
        return email_validation.test(input.value);
    } else {
        return new RegExp(input.pattern).test(input.value);
    }
}
Cf._number_validation = function(input) {
    if (input.id === 'budget') {
        input.min = this._get_buget_min_value();
    }

    if (!input.min || !input.max) return true;
    return (parseFloat(input.value) >= input.min && parseFloat(input.value) < input.max);
}

Cf._get_buget_min_value = function() {
    var issuer = document.getElementById('issuer');
    return (issuer.value === 'Create a new account') ? 500 : 100;
}

Cf._get_budget_warn = function() {
    var minBugetValue = this._get_buget_min_value();
    return 'Allowed only numeric value from ' + minBugetValue + ' to 999999';
}

Cf._do_validation_inputs = function(input) {

    if ((!this._string_validation(input) || !this._number_validation(input)) || input.value === '') {

        input.classList.add('is-invalid');
        input.parentNode.appendChild(input.warn);

        this.invalids[input.counter] = input;

    }
    // if valid
    else {

        input.classList.remove('is-invalid');
        this.shadow.appendChild(input.warn);

        this.invalids[input.counter] = null;

        input.is_valid = false;

    }

    // if empty 
    if (input.value === '') {
        input.classList.remove('is-invalid');
        this.shadow.appendChild(input.warn);
    }

    this._pass_validation();

};



Cf._do_validation_select = function(select, from_event) {

    if (select.id === 'issuer') {
        var budget = document.getElementById('budget');
        var budgetWarning = budget.parentNode.getElementsByClassName('cf-validation-warn');
        if (budgetWarning.length > 0) {
            budgetWarning[0].innerHTML = this._get_budget_warn();
            budget.value = '';
        }
    }

    if (select.getAttribute('aria-required', 'true')) {
        if (!select.value) {

            if (from_event) {
                select.classList.add('is-invalid');
                select.parentNode.appendChild(select.warn);
            }

            this.invalids[select.counter] = select;
        } else {
            if (from_event) {
                select.classList.remove('is-invalid');
                this.shadow.appendChild(select.warn);
            }

            this.invalids[select.counter] = null;
        }

    }

    this._pass_validation();

};

Cf._do_validation_checkbox = function(checkbox, from_event) {

    if (!checkbox.checked) {
        if (from_event) {
            checkbox.parentNode.appendChild(checkbox.warn);
        }
        this.invalids[checkbox.counter] = checkbox;
    } else {
        if (from_event) {
            this.shadow.appendChild(checkbox.warn);
        }
        this.invalids[checkbox.counter] = null;
    }

    this._pass_validation();

};

Cf.handle_select_boxes = function() {

    const selects = this.form.querySelectorAll('select');

    selects.length && [].forEach.call(selects, (select, i) => {

        if (!select.getAttribute('aria-required', 'true')) return;

        // make first value placeholder
        select.options[0].value = '';
        select.counter = 'select-' + i;
        select.warn = this._create_warn_label('Please select an option');

        //	this.invalids[select.counter] = select;

        select.addEventListener('change', () => {
            this._do_validation_select(select, true);
        });
        this._do_validation_select(select);
    });
};

Cf.handle_inputs = function() {

    const inputs = this.form.querySelectorAll('input[aria-required="true"]');

    inputs.length && [].forEach.call(inputs, (input, i) => {

        // filter by validation object
        const validation_obj = this.validation[input.id];

        if (!validation_obj) return;

        try {

            if (input.id === 'budget') {
                input.warn = this._create_warn_label(this._get_budget_warn());
            } else {
                input.warn = this._create_warn_label(validation_obj.help);
            }

            input.pattern = validation_obj.pattern;
            input.counter = 'input-' + i;
            input.min = validation_obj.min || '';
            input.max = validation_obj.max || '';

            input.addEventListener('keyup', () => {
                this._do_validation_inputs(input);
            });

            this._do_validation_inputs(input);

        } catch (err) { console.log(err) }

    });

};

Cf.handle_checkbox = function() {

    var required_checkboxs = document.querySelectorAll('.has-checkbox-required input[type="checkbox"]');

    required_checkboxs.length && [].forEach.call(required_checkboxs, (checkbox, i) => {

        checkbox.counter = 'checkbox-' + i;
        checkbox.warn = this._create_warn_label('Please approve the terms');
        checkbox.addEventListener('change', () => {
            this._do_validation_checkbox(checkbox, true);
        });

        this._do_validation_checkbox(checkbox, false);

    });

};

Cf.conditional_fields = function() {

    const conditional_fields = this.form.querySelectorAll('[data-conditional]');

    if (!conditional_fields.length) return;

    [].forEach.call(conditional_fields, (field) => {

        var condition = field.getAttribute('data-conditional').split(' === '),
            inputs = this.form.querySelectorAll('[name="' + condition[0] + '"]');

        inputs.length && [].forEach.call(inputs, (input) => {

            const fiteld_input = field.querySelector('input') || document.createElement('input');

            input.addEventListener('change', () => {
                if (input.value == condition[1]) {
                    field.classList.remove('is-hidden');
                    fiteld_input.classList.add('wpcf7-validates-as-required');
                    fiteld_input.setAttribute('aria-required', 'true');
                } else {
                    field.classList.add('is-hidden');
                    fiteld_input.classList.remove('wpcf7-validates-as-required');
                    fiteld_input.removeAttribute('aria-required');
                }
                this._pass_validation();

            });
        });

    });


};

Cf.custom_validation_on_submit = function() {
    document.addEventListener('wpcf7submit', (event) => {

        Object.keys(this.invalids).forEach((key) => {

            var input = this.invalids[key];
            if (!input) return;
            input.classList.add('is-invalid');
            input.parentNode.appendChild(input.warn);

        });
    });
};

// more customizations ( not relevant to validation )

Cf.get_institution_select_value = function() {

    const input = this.form.querySelector('[id="institution_number"]'),
        inst_select = this.form.querySelector('select[id="inst"]');

    if (!input || !inst_select) return;

    function update_input() {
        var serial = inst_select.options[inst_select.selectedIndex].serial;
        if (serial) {
            input.value = serial;
        } else {
            input.value = '';
        }
    }

    [].forEach.call(inst_select.options, (option) => {

        var str = option.textContent;

        if (str.indexOf(':') === -1) return;

        option.serial = str.split(':')[1];
        option.textContent = str.split(':')[0];

    });

    update_input();

    inst_select.addEventListener('change', (e) => {
        update_input();
    });
};

Cf.add_read_only = function() {

    var has_readonly = document.querySelectorAll('.has-readonly input');

    has_readonly.length && [].forEach.call(has_readonly, (input) => {
        input.setAttribute('readonly', 'true');
    });
};

// new Cloud_form('.iucc-form');

document.addEventListener('wpcf7beforesubmit', (event) => {
    var invalids = document.getElementsByClassName('is-invalid');
    while (invalids.length > 0) {
        invalids[0].classList.remove('is-invalid');
    }
});

document.addEventListener('wpcf7invalid', (event) => {
    var invalidFields = event.detail.apiResponse.invalidFields;
    Object.keys(invalidFields).forEach((key) => {
        var input = document.getElementById(invalidFields[key].idref);
        input.classList.add('is-invalid');
    });
});

document.addEventListener('wpcf7mailsent', (event) => {
    if (event.detail.apiResponse.proposal_id) {
        var proposalId = document.getElementById('proposal_id');
        proposalId.setAttribute('value', event.detail.apiResponse.proposal_id);
    }
});


// WEBPACK FOOTER //
// ./assets/js/m-cloud-form.js